var sqrt3 = Math.sqrt(3);

export default {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/symbol/triangle.js
// module id = 658
// module chunks = 0